import { render, staticRenderFns } from "./healthfollow.vue?vue&type=template&id=55ec88c7&"
import script from "./healthfollow.vue?vue&type=script&lang=js&"
export * from "./healthfollow.vue?vue&type=script&lang=js&"
import style0 from "./healthfollow.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports